import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { InputBase, TextAreaBase } from './styles';
import { useMultipleEditionStore } from '../../../../stores/useMultipleEditionStore';
import { useAutoPrefill } from '../../../../hooks/useAutoPrefill';

const CustomInputME = ({
  id,
  type,
  placeholder,
  value,
  defaultValue,
  onChange,
  onBlur,
  variant = 'gray',
  disabled = false,
  isError = false,
  id_attribute,
  articleId,
  typeDescription,
  max_char,
}) => {
  const realType = typeDescription === 'Alfanumérico' ? 'text' : 'number';
  const { getSingleAttributeObj, setMultipleDataObjValue, setMultipleDataObjAproval, rules, attributesDisabled, fetchRules } =
    useMultipleEditionStore();
  // const obj = getSingleAttributeObj(articleId, id_attribute);

  const { applyRules, markAsEdited, applyInitialRules } = useAutoPrefill();

  const obj = useMultipleEditionStore((state) => 
    state.multipleEditionData
      .find(a => a.articleId === articleId)
      ?.articleData.find(attr => attr.id_attribute === id_attribute)
  );

  const isCurrentlyTargeted = useMultipleEditionStore((state) => {
    const article = state.multipleEditionData.find(a => a.articleId === articleId);
    if (!article || !state.rules) return false;

    const myRules = state.rules.filter(r => Number(r.target_attribute_id) === Number(id_attribute));

    return myRules.some(rule => {
      const sourceAttr = article.articleData.find(attr => attr.id_attribute === rule.source_attribute_id);
      const currentValue = sourceAttr?.value;

      if (rule.source_value === null) return !!currentValue;

      return Array.isArray(rule.source_value) && rule.source_value.includes(currentValue);
    });
  });

  const isHardDisabled = React.useMemo(() => {
    return attributesDisabled?.includes(Number(id_attribute));
  }, [attributesDisabled, id_attribute]);

  const editable = !isCurrentlyTargeted && !isHardDisabled;

  // ID de atributos predefinidos

  useEffect(() => {
      fetchRules();
  }, [fetchRules]);


  const [selectedValue, setSelectedValue] = useState(obj?.value);
  useEffect(() => {
    setSelectedValue(obj?.value);
  }, [value, obj]);

  const handleChange = (e) => {

    if(!editable) return;

    let inputValue = e.target.value;
    if (realType === 'number') {
      inputValue = inputValue.replace(/[^0-9.]/g, '');
      const parts = inputValue.split('.');
      if (parts.length > 2) {
        inputValue = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts[1] !== undefined && parts[1].length > 4) {
        inputValue = parts[0] + '.' + parts[1].slice(0, 4);
      }
    }

    if (max_char > 0 && inputValue.length > max_char) return;

    markAsEdited(articleId, id_attribute);
    setMultipleDataObjValue(articleId, id_attribute, inputValue);
  };

  const handleBlur = (e) => {
    const val = realType === 'number'
      ? e.target.value.replace(/[^0-9.]/g, '')
      : e.target.value;
    if (val) {
      setMultipleDataObjAproval(articleId, id_attribute, 1, null);
    }
    applyRules(articleId, id_attribute, val);
  };

  if (type === 'textarea') {
    return (
      <TextAreaBase
        id={id}
        placeholder={placeholder}
        value={obj?.value}
        defaultValue={defaultValue}
        onClick={(e) => {
          if(!editable) e.preventDefault();
        }}
        onChange={(e) => {
          if (max_char > 0 && e.target.value.length > max_char) return;
          markAsEdited(articleId, id_attribute);
          setMultipleDataObjValue(articleId, id_attribute, e.target.value);
        }}
        onBlur={(e) => {
          if (e.target.value) {
            setMultipleDataObjAproval(articleId, id_attribute, 1, null);
          }
          applyRules(articleId, id_attribute, e.target.value);
        }}
        variant={variant}
        disabled={disabled}
        editable={editable}
        isError={isError}
      />
    );
  }

  return (
    <InputBase
      id={id}
      type={type}
      maxLength={max_char}
      placeholder={placeholder}
      value={obj?.value || ""} 
      onClick={(e) => {
        if(!editable) e.preventDefault();
      }}
      onChange={handleChange}
      onBlur={handleBlur}
      variant={variant}
      disabled={disabled}
      editable={editable}
      isError={isError}
    />
  );
};

CustomInputME.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'tel', 'textarea']),
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['gray', 'graylight']),
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
};

export default CustomInputME;